export const VALIDATION_TYPES = Object.freeze({
    PATTERN: 'pattern',
    REQUIRED: 'required',
});

export const FORMAT_TYPES = Object.freeze({
    UPPER_CASE: 'upperCase',
});
